// *******************************************************************************
// Our Vision
// *******************************************************************************

const ourVisionModule = document.querySelectorAll('.our-vision');

if (ourVisionModule.length > 0) {
  let ourVisionEle = null;

  const initOurVisionScrollMagic = () => {
    ourVisionEle = new ScrollMagic.Controller();

    ourVisionModule.forEach((element) => {
      const parentElem = element.closest('.sc-our-vision');
      const allItems = parentElem.querySelectorAll('.our-vision__item');

      // Slides
      allItems.forEach((item, index) => {
        const titles = item.querySelectorAll('.word');
        const prevItem = index > 0 ? allItems[index - 1] : null;
        const prevTitles = prevItem?.querySelectorAll('.word');

        const titleTween = gsap.timeline({ defaults: { ease: 'none', stagger: 0.05 } });

        titleTween.to(titles, {
          color: '#262626',
          ease: 'none',
          filter: 'blur(0)',
        });

        if (prevTitles) {
          titleTween.to(
            prevTitles,
            {
              color: '#d4d4d4',
              ease: 'none',
              filter: 'blur(0.1rem)',
            },
            0,
          );
        }

        new ScrollMagic.Scene({
          triggerElement: item,
          duration: item.clientHeight,
          triggerHook: 0.6,
          reverse: true,
        })
          // .addIndicators({ name: 'Sticky Header' })
          .setTween(titleTween)
          .addTo(ourVisionEle);
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    initOurVisionScrollMagic();
  });
}
